import { injectable } from 'inversify';
import { Vue } from 'vue-property-decorator';
import * as Api from "@/app/interaction/api";
import { queryElements, replaceWithElement } from '@/app/shared/utils/content-utils';
import { createInteractionComponent } from '@/app/interaction/ui'
import { CodeContent } from './code-content';

@injectable()
export class IncludeCodeHandler implements Api.IncludeComponentsHandlerInterface {
  
  public async includeComponents($parsedContent: any): Promise<Vue[]> {
    const elements: any = queryElements('.code.component', $parsedContent);
    if (elements === null) {
      return []
    }

    let components = []
    for (const element of elements) {
      const $element: any = $(element);
      const component = this.includeComponent($element);
      components.push(component)
    }

    return components
  }

  private includeComponent($element: any): Vue {
    const id: string = $element.attr('id');
    const title: string = $('.code__title', $element).text();
    const language: string = $element.attr('data-language') || '';
    const linenums: string = $element.attr('data-linenums') || '';
    const highlight: string = $element.attr('data-highlight') || '';
    const code: string = $('.code__content pre code', $element).html() || '';
    
    const interactionComponent = createInteractionComponent<CodeContent, {}>(id, 'code', {
      title: title,
      instruction: null
    }, {
      language,
      linenums: linenums === '1',
      highlight,
      code: code
    })
    interactionComponent.$mount();

    replaceWithElement(`#${id}`, interactionComponent.$el);

    return interactionComponent
  }
}
